// src/components/prodComboBoxByMachine.js
// Igual que ProdListByMachineBut, pero como input editable: permite elegir
// de la lista desplegable (datalist) o digitar la referencia manualmente.
// Los productos mostrados dependen de la maquina seleccionada (cod_maq).
import React, { useEffect, useId, useState } from "react";
import { getProductsByMachine } from "../api";

/**
 * Selector de productos por maquina (opcional), editable.
 * Props:
 * - id_c: string (requerido)
 * - cod_maq: string (maquina seleccionada). Si no hay, el input se deshabilita.
 * - value: string (id_prod) - controlado
 * - onSelect: function(newValue) -> void
 * - placeholder: string (default "— Sin producto —")
 */
const ProdComboBoxByMachine = ({
  id_c,
  cod_maq,
  value,
  onSelect,
  placeholder = "— Sin producto —",
}) => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const datalistId = useId();

  // Cuando cambia la maquina, limpiamos seleccion local
  useEffect(() => {
    if (onSelect) onSelect(""); // reset producto al cambiar maquina
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cod_maq]);

  useEffect(() => {
    let alive = true;
    const load = async () => {
      if (!id_c || !cod_maq) {
        setItems([]);
        return;
      }
      setLoading(true);
      try {
        const data = await getProductsByMachine(id_c, cod_maq); // { products: [...] }
        if (!alive) return;
        setItems(Array.isArray(data?.products) ? data.products : []);
      } catch (e) {
        console.error("❌ Error loading products by machine:", e);
        if (alive) setItems([]);
      } finally {
        if (alive) setLoading(false);
      }
    };
    load();
    return () => { alive = false; };
  }, [id_c, cod_maq]);

  const disabled = !cod_maq || loading;

  return (
    <>
      <input
        className="input1"
        type="text"
        list={datalistId}
        value={value || ""}
        onChange={(e) => onSelect && onSelect(e.target.value)}
        placeholder={loading ? "Cargando..." : placeholder}
        disabled={disabled}
        autoComplete="off"
      />
      <datalist id={datalistId}>
        {!loading && items.map((p) => (
          <option key={`${p.id_prod}-${p.cod_maq || "x"}`} value={p.id_prod}>
            {p.id_prod}{p.name_prod ? ` — ${p.name_prod}` : ""}
          </option>
        ))}
      </datalist>
    </>
  );
};

export default ProdComboBoxByMachine;
